export default __webpack_public_path__ + "static/media/connected.4a9b84e9.svg";